import styled from 'styled-components'

const CommentsCountStyle = styled.div.attrs()`
	.imageCont {
		width: var(--sp3x);
    	height: var(--sp3x);
   		margin-right: var(--spSize);
	}

	i {
		font-size: 20px;
		margin-right: var(--spSize);

		.path1 {
			&:before {
				color:var(--grey);
			}
		}

		.path2 {
			&:before {
				transition: 0.3s;
				color:transparent;
			}
		}

		&.active {
			.path2{
				&:before {
					color:var(--red);
				}
			}
		}
		
		&:hover {
			.path2 {
				&:before {
					color:var(--red);
				}
			}
		}
	}
`

export default CommentsCountStyle
